import React from "react";
import PropTypes from "prop-types";

import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  CartesianGrid,
} from "recharts";

import styles from "./AllocToPdqGraph.module.css";

const CustomTooltip = ({ active, payload, label, selectedDropLossType }) => {
  if (active && payload?.length) {
    return (
      <div className={styles.tooltipBox}>
        <div className={styles.tooltipDate}>{label}</div>

        <div className={styles.blue}>
          {selectedDropLossType} :{" "}
          {payload?.[0]?.value?.toLocaleString?.() ?? 0} %
        </div>
      </div>
    );
  }

  return null;
};

CustomTooltip.propTypes = {
  active: PropTypes.bool,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  payload: PropTypes.array,
  selectedDropLossType: PropTypes.string,
};

CustomTooltip.defaultProps = {
  active: false,
  label: "",
  payload: [],
  selectedDropLossType: "Stock Issue Loss",
};

const formatDate = (date) => {
  const d = new Date(date);

  const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "July",
    "Aug",
    "Sept",
    "Oct",
    "Nov",
    "Dec",
  ];

  return `${d.getDate()} ${months[d.getMonth()]}`;
};

const NrAllocDropGraph = ({ data, loading, selectedDropLossType }) => {
  if (loading) {
    return (
      <div className={styles.shimmerWrapper}>
        <div className={styles.shimmerChart}></div>
      </div>
    );
  }

  if (!data?.length) {
    return <div className={styles.centerState}>No Data</div>;
  }

  const chartWidth = data.length > 10 ? `${data.length * 60}px` : "100%";

  return (
    <div className={styles.graphContainer}>
      <div className={styles.horizontalScroll}>
        <div className={styles.chartWrapper} style={{ width: chartWidth }}>
          <ResponsiveContainer width="100%" height="100%">
            <LineChart
              data={data}
              margin={{
                top: 10,
                right: 20,
                left: 0,
                bottom: 0,
              }}
            >
              <CartesianGrid
                strokeDasharray="3 3"
                horizontal={false}
                vertical
              />

              <XAxis
                dataKey="IngestedDate"
                tick={{ fontSize: 12 }}
                tickFormatter={formatDate}
                interval={0}
              />

              <YAxis tick={{ fontSize: 12 }} />

              <Tooltip
                content={
                  <CustomTooltip
                    selectedDropLossType={selectedDropLossType}
                  />
                }
              />

              <Line
                type="monotone"
                dataKey="drop loss percent"
                stroke="#e75fc5"
                strokeWidth={2}
                dot={{
                  r: 3,
                  fill: "#e75fc5",
                  stroke: "#e75fc5",
                }}
                activeDot={{
                  r: 5,
                  fill: "#ef3dc3",
                  stroke: "#ef3dc3",
                }}
                name={selectedDropLossType}
              />
            </LineChart>
          </ResponsiveContainer>
        </div>
      </div>
    </div>
  );
};

NrAllocDropGraph.propTypes = {
  data: PropTypes.array,
  loading: PropTypes.bool,
  selectedDropLossType: PropTypes.string,
};

NrAllocDropGraph.defaultProps = {
  data: [],
  loading: false,
  selectedDropLossType: "Stock Issue Loss",
};

export default NrAllocDropGraph;